<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10 px-5">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                "pushNotifications" | translate
              }}</span>
            </h3>
          </div>

          <!-- Push notification List -->
          <div class="card-body py-3">
            <div class="table-responsive">
              <!-- Push notification Table Loading -->
              <div
                *ngIf="pushNotificationListLoading; else pushNotificationList"
                class="d-flex justify-content-center pb-4"
              >
                <div class="spinner-border text-danger" role="status">
                  <span class="visually-hidden"
                    >pushNotificationListLoading...</span
                  >
                </div>
              </div>
              <ng-template #pushNotificationList>
                <!-- If no push notification available -->
                <div
                  *ngIf="!pushNotifications?.length; else showNotificationList"
                  class="card-body py-3 text-center fs-5"
                >
                  {{ "noPushNotificationsAvailableToBeDisplayed" | translate }}
                </div>
                <!-- Accordion List -->
                <ng-template #showNotificationList>
                  <div class="accordion shadow-sm" id="accordionExample">
                    <div
                      *ngFor="
                        let notification of pushNotifications;
                        let i = index
                      "
                      class="accordion-item"
                    >
                      <h2 class="accordion-header cursor-pointer">
                        <button
                          class="accordion-button text-dark collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          [attr.data-bs-target]="'#collapse' + i"
                          aria-expanded="false"
                          [attr.aria-controls]="'collapse' + i"
                        >
                          <div class="d-flex align-items-center gap-4">
                            <div>
                              <strong>
                                {{ "subject" | translate }} ({{
                                  getLanguageText(
                                    notification.translations[0].languageCode
                                  )
                                }}):
                              </strong>
                              {{ notification.translations[0].subject || "-" }}
                            </div>
                            -
                            <div>
                              <strong>
                                {{ "subject" | translate }} ({{
                                  getLanguageText(
                                    notification.translations[1].languageCode
                                  )
                                }}):
                              </strong>
                              {{ notification.translations[1].subject || "-" }}
                            </div>
                          </div>
                        </button>
                      </h2>
                      <div
                        [attr.id]="'collapse' + i"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center gap-12"
                        >
                          <div class="accordion-body">
                            <div
                              *ngFor="
                                let content of notification.translations;
                                let isLast = last
                              "
                            >
                              <p>
                                <strong
                                  >{{ "body" | translate }} ({{
                                    getLanguageText(content.languageCode)
                                  }}):</strong
                                >
                                <!-- {{ content.body || "-" | truncate : 400 }} -->
                                {{ content.body }}
                              </p>

                              <hr *ngIf="!isLast" class="mt-0" />
                            </div>
                          </div>
                          <!-- Edit Notification -->
                          <a
                            (click)="navigateToEdit(notification)"
                            class="edit-btn btn btn-icon btn-active-color-primary cursor-pointer me-6"
                            [title]="'edit' | translate"
                            ><i class="fa-regular fa-pen-to-square"></i
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-template>
            </div>
          </div>
        </div>
        <!-- Pagination -->
        <div class="d-flex flex-stack flex-wrap pt-10">
          <div class="d-flex align-items-center gap-6">
            <div class="flex align-items-center">
              <label
                for="pageSizeSelect"
                class="me-2 fs-6 fw-semibold text-gray-700"
                >{{ "pageSize" | translate }}:</label
              >
              <select
                id="pageSizeSelect"
                (change)="changePageSize($event)"
                class="cursor-pointer outline-none"
              >
                <option *ngFor="let size of pageSizes" [value]="size">
                  {{ size }}
                </option>
              </select>
            </div>
            <div class="fs-6 fw-semibold text-gray-700">
              {{ "showing" | translate }} {{ pushNotifications.length }}
              {{ "of" | translate }} {{ totalPushNotifications }}
              {{ "notifications" | translate }}
            </div>
          </div>
          <ul class="pagination">
            <li
              class="page-item previous cursor-pointer"
              [class.disabled]="currentPage === 1"
            >
              <a class="page-link" (click)="changePage(currentPage - 1)">
                <i class="previous"></i>
              </a>
            </li>
            <li
              *ngFor="let page of [].constructor(totalPage); let i = index"
              class="page-item cursor-pointer"
              [class.active]="currentPage === i + 1"
            >
              <a class="page-link" (click)="changePage(i + 1)">{{ i + 1 }}</a>
            </li>
            <li
              class="page-item next cursor-pointer"
              [class.disabled]="currentPage === totalPage"
            >
              <a class="page-link" (click)="changePage(currentPage + 1)">
                <i class="next"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
